import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { EntityContext } from 'context/entityContext';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import { FakeDropdown } from 'components/base/SkeletonLoader/FakeInteractive';
import ComponentControls from 'components/styled/ComponentControls/ComponentControls';
import ResponsiveSVG from 'components/base/svg/ResponsiveSVG';
import SkeletonMap from './SkeletonMap';
import Background from 'components/base/svg/Background';
import Border from 'components/base/svg/Border';
import { MapWrapper } from './styles';
import ZoomControls from 'components/base/svg/ZoomControls';
import EntityToggleList from 'components/EntityToggleList';
import { checkIsExternalUser } from 'redux/reducers/authentication';

const noop = (): any => {}; // eslint-disable-line @typescript-eslint/no-empty-function

function TerritoryMapSkeletonLoader(props: any): any {
  const { title = 'Territory Performance', showSalesTypesDropdown } = props;
  const isExternalUser = useSelector(checkIsExternalUser);

  const { compareMode, dataColors, entityIds, entityType } = useContext(
    EntityContext
  );

  return (
    <GenericComponent loading={true} title={title} isNarrowScreen>
      <ComponentControls alignRight={false}>
        <FakeDropdown>This week to date</FakeDropdown>
        {showSalesTypesDropdown && (
          <FakeDropdown>
            {isExternalUser ? 'Streams' : 'Album Equivalents'}
          </FakeDropdown>
        )}
      </ComponentControls>

      {compareMode === 'entity' && (
        <EntityToggleList
          entityType={entityType}
          entityIds={entityIds}
          selectedEntity={entityIds[0]}
          colors={dataColors}
          selectEntity={noop}
        />
      )}

      <MapWrapper>
        <ResponsiveSVG>
          {(size: any): any => (
            <g opacity={0.6}>
              <Background {...size} />
              <Border x1={0} x2={size.width} y1={0} y2={0} />
              <Border
                x1={0}
                x2={size.width}
                y1={size.height}
                y2={size.height}
              />
              <SkeletonMap {...size} />
            </g>
          )}
        </ResponsiveSVG>

        <ZoomControls
          disabled
          zoomIn={noop}
          zoomOut={noop}
          resetZoom={noop}
          currentZoom={1}
          zoomExtent={[0, 1]}
        />
      </MapWrapper>
    </GenericComponent>
  );
}

export default TerritoryMapSkeletonLoader;
